import { render } from "./ProjectModalCreator.vue?vue&type=template&id=a56960fc"
import script from "./ProjectModalCreator.vue?vue&type=script&lang=js"
export * from "./ProjectModalCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectModalCreator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a56960fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a56960fc', __exports__)) {
    api.reload('a56960fc', __exports__)
  }
  
  module.hot.accept("./ProjectModalCreator.vue?vue&type=template&id=a56960fc", () => {
    api.rerender('a56960fc', render)
  })

}


export default __exports__